import RemoteConfig from './RemoteConfig'
import { ajax } from './ajax'
import { deepMerge } from './utils'

export function getConfig (localConfig) {
  if (!localConfig || (!localConfig.zone_id && !localConfig.zoneId)) {
    throw Error('Missing zone_id')
  }

  const zoneId = localConfig.zone_id || localConfig.zoneId

  return new Promise((resolve, reject) => {
    ajax('//market-global.smrtb.com/json/publisher/prebid/config?zoneId=' + zoneId).then(data => {
      const config = data

      resolve(new RemoteConfig(zoneId, deepMerge(config, localConfig)))
    }).catch((err) => {
      reject(Error('Fetching config failed, HTTP status ' + err.status))
    })
  })
}
